import { gql } from "@apollo/client";

export const GET_ESTADO_PACIENTE = gql`
  query getAllEstadoPaciente {
    allEstadoPaciente {
      idEstadoPaciente
      codigo
      descripcion
      t_Paciente {
        idPaciente
      }
    }
  }
`;